"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIconNew = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Search Icon
 */
function SearchIconNew({ size, ...attrs }) {
    return ((0, jsx_runtime_1.jsxs)("svg", { ...attrs, width: size, height: size, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 2.0625C3.37766 2.0625 2.0625 3.37766 2.0625 5C2.0625 6.62234 3.37766 7.9375 5 7.9375C6.62234 7.9375 7.9375 6.62234 7.9375 5C7.9375 3.37766 6.62234 2.0625 5 2.0625ZM0.9375 5C0.9375 2.75634 2.75634 0.9375 5 0.9375C7.24366 0.9375 9.0625 2.75634 9.0625 5C9.0625 7.24366 7.24366 9.0625 5 9.0625C2.75634 9.0625 0.9375 7.24366 0.9375 5Z" }), (0, jsx_runtime_1.jsx)("path", { d: "M7.85133 7.14488L7.14423 7.85199L9.64385 10.3516L10.351 9.64451L7.85133 7.14488Z" })] }));
}
exports.SearchIconNew = SearchIconNew;
//# sourceMappingURL=SearchIconNew.js.map